import { regexOnlyNumber } from 'shell/constants/regex';
import * as yup from 'yup';

export const commonSchemaObject = {
  year: yup.string().required('Campo obbligatorio').matches(regexOnlyNumber, 'Campo numerico'),
  registerNumber: yup.string().required('Campo obbligatorio'),
  documentNumber: yup
    .string()
    .required('Campo obbligatorio')
    .matches(regexOnlyNumber, 'Campo numerico'),
  portion: yup.string().matches(regexOnlyNumber, 'campo numerico').required('Campo obbligatorio'),
  //   upload: yup.object().nullable().required('Campo Obbligatorio'),
};
